import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import Nav from "@/components/Nav";
import Landing from "@/pages/Landing";
import Retailer from "@/pages/Retailer";
import Customer from "@/pages/Customer";
import Verify from "@/pages/Verify";
import Verification from "@/pages/Verification";
import Claim from "@/pages/Claim";
import Demo from "@/pages/Demo";
import Login from "@/pages/Login";
import { AuthProvider, ProtectedRoute } from "@/lib/auth";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Nav />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route
              path="/retailer"
              element={
                <ProtectedRoute>
                  <Retailer />
                </ProtectedRoute>
              }
            />
            <Route
              path="/customer"
              element={
                <ProtectedRoute>
                  <Customer />
                </ProtectedRoute>
              }
            />
            <Route
              path="/verification"
              element={
                <ProtectedRoute>
                  <Verification />
                </ProtectedRoute>
              }
            />
            <Route path="/verify" element={<Verify />} />
            <Route path="/verify/:nftId" element={<Verify />} />
            <Route path="/claim/:claimToken" element={<Claim />} />
            <Route path="/demo" element={<Demo />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster
            position="bottom-right"
            richColors
            toastOptions={{
              style: {
                fontFamily: "Manrope, sans-serif",
                borderRadius: "12px",
              },
            }}
          />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
